/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useMemo, useState} from "react"
import {KlassDropdown} from "components/Select"
import {translate} from "helpers"
import {CalendarViewOption, CalendarViewType, DEFAULT_CALENDAR_VIEW, findViewOption} from "../../calendarViews"
import styles from "./ViewOptions.module.css"

type ViewOptionsProps = {
    viewOptions?: CalendarViewOption[]
    t: Function
    onChange: (viewType: CalendarViewType) => void
    updateViewTo?: CalendarViewType
}

const DEFAULT_VIEW_OPTIONS: CalendarViewOption[] = [
    {value: CalendarViewType.Day, label: translate("calendar:calendar.options.Day")},
    {value: CalendarViewType.Week, label: translate("calendar:calendar.options.Week")},
    {value: CalendarViewType.Month, label: translate("calendar:calendar.options.Month")}
]

export const ViewOptions = ({viewOptions, t, onChange, updateViewTo}: ViewOptionsProps) => {
    const options = viewOptions ?? DEFAULT_VIEW_OPTIONS
    const defaultOption = useMemo(
        () => findViewOption(DEFAULT_CALENDAR_VIEW, options) ?? DEFAULT_VIEW_OPTIONS[1],
        [options]
    )
    const [selectedOption, setSelectedOption] = useState(defaultOption)

    useEffect(() => {
        if (!updateViewTo) {
            return
        }

        const matchedOption = findViewOption(updateViewTo, options)
        if (matchedOption) {
            setSelectedOption(matchedOption)
        }
    }, [updateViewTo, options])

    const handleViewChange = (option: CalendarViewOption) => {
        setSelectedOption(option)
        onChange(option.value)
    }

    return (
        <div className={styles.weekOptions}>
            <KlassDropdown
                value={selectedOption}
                placeholder=""
                closeMenuOnSelect
                defaultValue={[defaultOption]}
                onChange={handleViewChange}
                options={options}
                valueKey="value"
                labelKey="label"
            />
        </div>
    )
}
